import React, { useState, useEffect, useRef } from "react";
import Input from "../../components/Input";
import { uploadImage, subadminAccessChange } from "../../utils/functions";
import axios from "../../axios";
import Overlay from "../../components/Overlay";
import { extractDate, extractOnlyDate } from "../../utils/functions";
import { get } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { Select, MenuItem } from '@mui/material';
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Modal } from "../../components/Modal";
import { bottom } from "@popperjs/core";
import './Dashboard.css';
import YearInput from '../../components/YearInput';

import { RiArrowDropDownLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import html2canvas from "html2canvas";

import ReactApexChart from "react-apexcharts";



// Mui & material UI
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import PaginationItem from "@mui/material/PaginationItem";

import {
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { Snackbar, Alert } from "@mui/material";

import {
  Box,
  Grid,
  Card,
  CardContent,
  Avatar,
  Button,
  Popover
} from "@mui/material";



// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  Heading,
  DashText,
  CardDetail,


} from "./DashboardElement";

import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Area,
  AreaChart,
} from "recharts";
import { LuDownload } from "react-icons/lu";
import { FaUserAlt } from "react-icons/fa";
import { PiConfettiFill } from "react-icons/pi";
import { BsPinAngleFill } from "react-icons/bs";


import { InputDivide, ProfileDetailForm } from "../../pages/Authentican/Profile/ProfileElements";

import Chart from 'react-apexcharts';

import FirstUser from "../../assets/images/firstUser.png";
import SecondUser from "../../assets/images/secondUser.png";
import TotalRevenue from "../../assets/images/TotalRevenue.png"
import ThirdUser from "../../assets/images/thirdUser.png";
import FourthUser from "../../assets/images/fourthUser.png";
import placeholder from "../../assets/images/placeholder.jpg"
import NoResults from "../NoResult";
import Nodata from "../Nodata";
import Loading from "../Loading";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    minHeight: "80vh",
    border: "1px solid #F0F1F3",
    borderRadius: "10px",
    overflow: "scroll",
  },
  tableMainContainer: {
    maxHeight: "60vh",
    overflowX: "scroll",
    overflowY: "scroll",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    // borderBottom: "F0F1F3",
    background: "#F9F9FC",
  },
  tableHeadingCell: {
    padding: "0.8rem 1rem !important",
    textAlign: "left",
    fontSize: "14px",
    color: "#333843",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",


  },
  tablseHeadingCell: {
    padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#264503",
    fontWeight: 600,
    // borderBottom: "1px solid #D9E3D9",
    // borderBottom: "1px solid #F0F1F3",
    whiteSpace: "nowrap",
  },
  textMiddle: {
    padding: "0.5rem 0.5rem !important",
    verticalAlign: "middle !important",
    textAlign: "left",
    fontSize: "14px",
    color: "#484848",
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
}));

const Dashboard = ({ setUsers, userData, }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const chartRef = useRef(null);
  // const chartRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [leaderBoardData, setLeaderBoardData] = useState([])
  const [skillData, setSkillData] = useState([])
  const [earningHistory, setEarningHistory] = useState([])
  const [typeCheck, setTypeCheck] = useState([])
  const [platformEarning, setPlatformEarning] = useState([])
  const [registeredBooking, setRegisteredBooking] = useState()
  const [filterStatus, setFilterStatus] = useState("all")
  const [filterMonths, setFilterMonths] = useState(new Date().getMonth())
  const [tableData, setTableData] = useState([])
  const [paymentHistory, setPaymentHistory] = useState([])
  const [isActive, setIsActive] = useState(false);

  const [gigOverViewData, setGigOverViewData] = useState()
  const [userOverViewData, setUserOverViewData] = useState()




  // Filter Start
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterDates, setFilterDates] = useState({ startDate: "", endDate: "" });
  const [anchorEl, setAnchorEl] = useState(null);

  const [showCustomFilter, setShowCustomFilter] = useState(false);
  const [tabSwitch, setTabSwitch] = useState(
    "3"
  ); // Default to ongoing

  const handleServiceTypeChange = (type) => {
    setTabSwitch(type);
    setIsLoading(true);
    localStorage.setItem("filterTypeBooking", type); // Save the active tab to localStorage
  };


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalDocs, setTotalDocs] = useState(0);
  const [pageData, setPageData] = useState(1);
  const [totalDocsData, setTotalDocsData] = useState(0);
  const [rowsPerPageData, setRowsPerPageData] = useState(5);


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage); // this will trigger useEffect
  };

  const handleChangeRowsPerPageData = (event) => {
    setRowsPerPageData(+event.target.value);
    setPageData(1); // Reset to the first page when rows per page change
  };

  const handleChangePageData = (event, newPage) => {

    setPageData(newPage); // this will trigger useEffect
  };



  const [time, setTime] = React.useState('');

  // const handleChange = (event) => {
  //   setTime(event.target.value);
  // };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;



  // revenue Graph
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth(); // 0 = Jan, 7 = Aug

  // years list (2024 se lekar currentYear tak)
  const years = [];
  for (let y = 2025; y <= currentYear; y++) {
    years.push(y);
  }

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(months[currentMonthIndex]);
  // Month filter logic
  const filteredMonths =
    selectedYear === currentYear
      ? months.slice(0, currentMonthIndex + 1) // sirf current month tak
      : months;

  const getMonthNumber = (monthName) => months.indexOf(monthName) + 1;

  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];

  // const currentYear = new Date().getFullYear();
  // const currentMonthIndex = new Date().getMonth(); // 0 = Jan, 7 = Aug

  // // years list (2024 se lekar currentYear tak)
  // const years = [];
  // for (let y = 2025; y <= currentYear; y++) {
  //   years.push(y);
  // }

  // const [selectedYear, setSelectedYear] = useState(currentYear);
  // const [selectedMonth, setSelectedMonth] = useState(""); // ✅ month blank by default

  // // Month filter logic
  // const filteredMonths =
  //   selectedYear === currentYear
  //     ? months.slice(0, currentMonthIndex + 1) // sirf current month tak
  //     : months;

  // const getMonthNumber = (monthName) =>
  //   monthName ? months.indexOf(monthName) + 1 : null; // ✅ agar month select na ho to null



  // Gigs Overview
  const [gigsYear, setGigsYear] = useState(currentYear);
  const [gigsMonth, setGigsMonth] = useState(months[currentMonthIndex]);

  const filteredGigsMonths =
    gigsYear === currentYear
      ? months.slice(0, currentMonthIndex + 1) // sirf current month tak
      : months;

  const getGigsMonthNumber = (monthName) => months.indexOf(monthName) + 1;


  // User Overview
  const [userYear, setUserYear] = useState(currentYear);
  const [userMonth, setUserMonth] = useState(months[currentMonthIndex]);


  const filteredUserMonths =
    userYear === currentYear
      ? months.slice(0, currentMonthIndex + 1)
      : months;

  const getUserMonthNumber = (monthName) => months.indexOf(monthName) + 1;








  // Fetch Dashboard data
  useEffect(() => {
    getDashboardData();
    getAdminEarningHistory();
    getGigOverViewData();
    getUserOverViewData();
    getRecentActivity(page)
    getPaymentHistory(pageData)

  }, [page, tabSwitch, pageData, rowsPerPage, rowsPerPageData, filterStatus, filterMonths, filterDates, selectedYear, selectedMonth, userYear, userMonth, gigsYear, gigsMonth]);





  const getDashboardData = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.get(`/private/getDashboardData`)

      setDashboardData(data?.data?.pendingProviders?.docs);
      setLeaderBoardData(data?.getTop5StreakersInBoard)
      setRegisteredBooking(data)
      setSkillData(data?.skillData)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };



  const getAdminEarningHistory = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(`/private/getAdminEarningHistory`, {
        year: selectedYear,
        month: getMonthNumber(selectedMonth)
      })


      setEarningHistory(data?.data)
      setPlatformEarning(data?.data)
      setTypeCheck(data)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };



  const getGigOverViewData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(`/private/getGigOverViewData`, {
        year: gigsYear,
        month: getGigsMonthNumber(gigsMonth)
      })

      setGigOverViewData(data?.data)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const getUserOverViewData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(`/private/getUserOverViewData`, {
        year: userYear,
        month: getUserMonthNumber(userMonth)
      })

      setUserOverViewData(data?.data)
    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };




  const getRecentActivity = async (currentPage) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getRecentActivity?page=${currentPage}&limit=${rowsPerPage}`, {
        pageType: String(tabSwitch),  // 1, 2, 3,
      })

      setTableData(data?.data?.docs)
      setTotalDocs(data?.data?.totalDocs);

    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };




  const getPaymentHistory = async (currentPage) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.get(`/private/getPaymentHistory?page=${currentPage}&limit=${rowsPerPageData}`)

      setPaymentHistory(data?.data?.docs)
      setTotalDocsData(data?.data?.totalDocs);

    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("Error", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };




  // gigOverViewData

  const data = [
    { name: "Active", value: gigOverViewData?.totalActiveGig ?? "00", color: "#34A853" },
    { name: "Completed", value: gigOverViewData?.totalCompletedGig ?? "00", color: "#4285F4" },    // Blue
    { name: "Inactive", value: gigOverViewData?.totalInActiveGig ?? "00", color: "#F4B400" },     // Yellow
    { name: "Ongoing", value: gigOverViewData?.totalOngoingGig ?? "00", color: "#EA4335" },     // Red
  ];

  const handleDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "gigs-overview-chart.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };



  // userOverViewData
  const dataUser = [

    { name: "Registered User", value: userOverViewData?.totalRegisterUser ?? "00", color: "#5088FB" },    // Blue
    { name: "Guest User", value: userOverViewData?.totalGuestUser ?? "00", color: "#86A7E9" },     // Yellow
    { name: "Pending Request", value: userOverViewData?.totalPendingUser ?? "00", color: "#4671CA" },
  ];

  const handleUserDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "gigs-overview-chart.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };





  // Revenue Profit Graph
  const categories = earningHistory.map((item, index) => {
    if (item.week) {
      return `Week-${index + 1}`;
    } else if (item.month) {
      return item.month;
    }
    return "";
  });

  const chartOptions = {
    chart: {
      type: "area",
      height: 300,
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    stroke: { curve: "smooth", width: 2 },
    dataLabels: { enabled: false },   //  values hat gayi
    xaxis: { categories },
    yaxis: {
      tickAmount: 6,
      forceNiceScale: true,
      labels: {
        formatter: (value) => {
          if (value >= 1000000) return "$" + (value / 1000000).toFixed(1) + "M";
          if (value >= 1000) return "$" + (value / 1000).toFixed(1) + "K";
          return "$" + value;
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => {
          if (value >= 1000000) return "$" + (value / 1000000).toFixed(1) + "M";
          if (value >= 1000) return "$" + (value / 1000).toFixed(1) + "K";
          return "$" + value;
        },
      },
    },
    colors: ["#3b82f6", "#FFD700"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [80, 100],
      },
    },
  };

  const chartSeries = [
    {
      name: "Revenue",
      data: earningHistory.map((item) => item.platformEarning),
    },
    {
      name: "Profit",
      data: earningHistory.map((item) => item.totalCommission),
    },
  ];

  // const handleRevenueDownload = () => {
  //   if (chartRef.current) {totalCommission
  //     chartRef.current.chart.dataURI().then(({ imgURI }) => {
  //       const link = document.createElement("a");
  //       link.href = imgURI;
  //       link.download = "revenue-chart.png";
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     });
  //   }
  // };



  return (
    <>
      <DashboardContainer>
        <DashboardWrapper >
          <ProfileDetailForm style={{ padding: "1rem" }}>
            <DashboardHeading>
              <Heading>
                <DashText>
                  <DashHeading>Dashboard</DashHeading>
                </DashText>
              </Heading>
            </DashboardHeading>



            {/* CardDAta */}
            <div className="main-card-container" >
              <div className="cardss">
                <CardContent >
                  <Box display="flex" gap="0.5rem">
                    <div><img src={FirstUser} style={{ background: "#FFFFFF", height: "2.1rem" }} /></div>
                    <div className="DashNameData">Total Registered Users</div>
                  </Box>
                  <div className="ViewDataNumber">
                    <div className="UsersDataDash">
                      {registeredBooking?.totalRegistrationUser ? registeredBooking?.totalRegistrationUser : "00"}
                    </div>
                  </div>
                </CardContent>
              </div>

              <div className="cardss">
                <CardContent>
                  <Box display="flex" gap="0.5rem">
                    <dive ><img src={SecondUser} style={{ height: "2.1rem" }} /></dive>
                    <div className="DashNameData">Total Guest User</div>
                  </Box>
                  <div className="ViewDataNumber">
                    <div className="UsersDataDash">
                      {registeredBooking?.totalGuestUser ? registeredBooking?.totalGuestUser : "00"}
                    </div>
                    {/* <div className="reports"
                      onClick={() => {
                        navigate(
                          `/userManagement?Tab=Guest`,
                          { state: { dashboardTab: "4" } }
                        );
                      }}
                    >View</div> */}
                  </div>
                </CardContent>
              </div>




              <div className="cardss">
                <CardContent>
                  <Box display="flex" gap="0.5rem">
                    <div ><img src={TotalRevenue} style={{ height: "2.1rem" }} /></div>
                    <div className="DashNameData">Total Revenue</div>
                  </Box>
                  <div className="ViewDataNumber">
                    <div className="UsersDataDash">
                      ${registeredBooking?.totalRevenue
                        ? registeredBooking.totalRevenue >= 1000
                          ? `${(registeredBooking.totalRevenue / 1000).toFixed(1)}k`
                          : registeredBooking.totalRevenue.toFixed(2)
                        : "00"}
                    </div>
                  </div>
                </CardContent>
              </div>




              <div className="cardss">
                <CardContent>
                  <Box display="flex" gap="0.5rem">
                    <div ><img src={ThirdUser} style={{ height: "2.1rem" }} /></div>
                    <div className="DashNameData">Total Active Gigs</div>
                  </Box>
                  <div className="ViewDataNumber">
                    <div className="UsersDataDash">
                      {registeredBooking?.totalActiveGig ? registeredBooking?.totalActiveGig : "00"}
                    </div>
                    {/* <div className="reports"
                      onClick={() => {
                        navigate(
                          `/gigsManagement`,
                          { state: { dashboardTab: "1" } }
                        );
                      }}
                    >
                      View</div> */}
                  </div>
                </CardContent>
              </div>

              <div className="cardss">
                <CardContent>
                  <Box display="flex" gap="0.5rem">
                    <div><img src={FourthUser} style={{ height: "2.1rem" }} /></div>
                    <div className="DashNameData">Admin Earnings</div>
                  </Box>
                  <div className="ViewDataNumber">
                    <div className="UsersDataDash">

                      ${registeredBooking?.adminEarnings
                        ? Number(registeredBooking.adminEarnings) >= 1000
                          ? (Number(registeredBooking.adminEarnings) / 1000).toFixed(2) + "K"
                          : Number(registeredBooking.adminEarnings).toFixed(2)
                        : "00.00"}
                    </div>
                  </div>
                </CardContent>
              </div>
            </div>


            {/* Revenue Graph */}
            <Grid className="abc">
              <Grid className="RevenueGraphData">
                <Card>
                  <div
                    ref={chartRef}
                    style={{
                      width: "100%",
                      height: 354,
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      padding: "1rem",
                      boxShadow: "0 0 10px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginRight: "2rem",
                        marginLeft: "1rem"
                      }}
                    >
                      <div style={{ display: "flex", gap: "1rem" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                          <div style={{ height: "0.8rem", width: "0.8rem", borderRadius: "50%", background: "#5088FB", }}></div>
                          Revenue
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                          <div style={{ height: "0.8rem", width: "0.8rem", borderRadius: "50%", background: "#F9D36F", }}>
                          </div> Profit
                        </div>
                      </div>

                      {/* select */}
                      <div style={{ display: "flex", gap: "1rem" }}>
                        {/* Year Dropdown */}
                        <select
                          value={selectedYear}
                          onChange={(e) => {
                            setSelectedYear(parseInt(e.target.value));
                            // agar current year hai to default current month select ho
                            if (parseInt(e.target.value) === currentYear) {
                              setSelectedMonth(months[currentMonthIndex]);
                            } else {
                              setSelectedMonth("January");
                            }
                          }}
                          style={{
                            padding: "8px 30px",
                            borderRadius: "8px",
                            border: "1px solid #DEDEDE",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            fontWeight: "400",
                            color: "#646464"

                          }}
                        >
                          {years.map((year) => (
                            <option key={year} value={year} style={{ border: "1px solid #DEDEDE", }}>
                              {year}
                            </option>
                          ))}
                        </select>

                        {/* Month Dropdown */}
                        <select
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            borderRadius: "8px",
                            border: "1px solid #DEDEDE",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            fontWeight: "400",
                            color: "#646464"
                          }}
                        >
                          {/* <option value="">Select Month</option> */}
                          {filteredMonths.map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                        {/*                         
                        <div onClick={handleRevenueDownload} style={{ padding: "4px 8px", fontSize: "12px", cursor: "pointer", }}>
                          <LuDownload style={{ color: "#858D9D", fontSize: "1.2rem" }} />
                        </div> */}
                      </div>

                    </div>

                    {chartSeries && chartSeries.length > 0 && chartSeries.some(s => s.data.length > 0) ? (
                      <ReactApexChart
                        ref={chartRef}
                        options={chartOptions}
                        series={chartSeries}
                        // type="line"
                        type="area"
                        height={320}
                      />
                    ) : (
                      <div style={{ marginTop: "3rem" }}>
                        <NoResults />
                      </div>
                    )}


                  </div>
                </Card>

              </Grid>
            </Grid>


            <Grid className="abc">
              <Grid className="abcde">
                <Card>
                  <div style={{ padding: "1rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                      <div className="DashPieChart">
                        Gigs Overview
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        {/* Select */}
                        <div style={{ display: "flex", gap: "0.6rem" }}>
                          {/* Year Dropdown */}
                          <select
                            value={gigsYear}
                            onChange={(e) => {
                              setGigsYear(parseInt(e.target.value));
                              // agar current year hai to default current month select ho
                              if (parseInt(e.target.value) === currentYear) {
                                setGigsMonth(months[currentMonthIndex]);
                              } else {
                                setGigsMonth("January");
                              }
                            }}
                            style={{
                              padding: "8px 30px",
                              borderRadius: "8px",
                              border: "1px solid #DEDEDE",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              fontWeight: "400",
                              color: "#646464"

                            }}
                          >
                            {years.map((year) => (
                              <option key={year} value={year} style={{ border: "1px solid #DEDEDE", }}>
                                {year}
                              </option>
                            ))}
                          </select>

                          {/* Month Dropdown */}
                          <select
                            value={gigsMonth}
                            onChange={(e) => setGigsMonth(e.target.value)}
                            style={{
                              padding: "8px 12px",
                              borderRadius: "8px",
                              border: "1px solid #DEDEDE",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              fontWeight: "400",
                              color: "#646464"
                            }}
                          >
                            {filteredGigsMonths.map((month) => (
                              <option key={month} value={month}>
                                {month}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div onClick={handleDownload} style={{ padding: "4px 8px", fontSize: "12px", cursor: "pointer", }}>
                          <LuDownload style={{ color: "#858D9D", fontSize: "1.2rem" }} />
                        </div>
                      </div>
                    </div>

                    {data && data.length > 0 && data.some(item => item.value > 0) ? (
                      <>
                        {/* Chart Section */}
                        <div ref={chartRef}>
                          <ResponsiveContainer width="100%" height={240}>
                            <PieChart>
                              <Pie
                                data={data}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={40}
                                outerRadius={80}
                                paddingAngle={0}
                              // label={({ value }) => value}
                              >
                                {data.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>

                        {/* Legend Section */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "1rem",
                          }}
                        >
                          {data.map((item) => (
                            <div
                              key={item.name}
                              style={{ display: "inline-block", margin: "0 12px", fontSize: "14px" }}
                            >
                              <div style={{ color: item.color, fontWeight: "bold" }}>{item.name}</div>
                              <div className="value_Number">{item.value}</div>
                            </div>
                          ))}
                          <div style={{ display: "inline-block", margin: "0 12px", fontSize: "14px" }}>
                            Total
                            <div className="value_Number">{gigOverViewData?.totalGigOverview}</div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          height: 240,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#888",
                          marginTop: "4.2rem"
                        }}
                      >
                        <NoResults />
                      </div>
                    )}

                  </div>
                </Card>
              </Grid>

              {/* User Overview */}
              <Grid className="abcde">
                <Card>
                  <div style={{ padding: "1rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                      <div className="DashPieChart">
                        User Overview
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <div style={{ display: "flex", gap: "0.6rem" }}>
                          {/* Year Dropdown */}
                          <select
                            value={userYear}
                            onChange={(e) => {
                              setUserYear(parseInt(e.target.value));
                              // agar current year hai to default current month select ho
                              if (parseInt(e.target.value) === currentYear) {
                                setUserMonth(months[currentMonthIndex]);
                              } else {
                                setUserMonth("January");
                              }
                            }}
                            style={{
                              padding: "8px 30px",
                              borderRadius: "8px",
                              border: "1px solid #DEDEDE",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              fontWeight: "400",
                              color: "#646464"

                            }}
                          >
                            {years.map((year) => (
                              <option key={year} value={year} style={{ border: "1px solid #DEDEDE", }}>
                                {year}
                              </option>
                            ))}
                          </select>

                          {/* Month Dropdown */}
                          <select
                            value={userMonth}
                            onChange={(e) => setUserMonth(e.target.value)}
                            style={{
                              padding: "8px 12px",
                              borderRadius: "8px",
                              border: "1px solid #DEDEDE",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              fontWeight: "400",
                              color: "#646464"
                            }}
                          >
                            {filteredUserMonths.map((month) => (
                              <option key={month} value={month}>
                                {month}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div onClick={handleUserDownload} style={{ padding: "4px 8px", fontSize: "12px", cursor: "pointer", }}>
                          <LuDownload style={{ color: "#858D9D", fontSize: "1.2rem" }} />
                        </div>
                      </div>
                    </div>

                    {dataUser && dataUser.length > 0 && dataUser.some(item => item.value > 0) ? (
                      <>
                        {/* Chart Section */}
                        <div ref={chartRef}>
                          <ResponsiveContainer width="100%" height={240}>
                            <PieChart>
                              <Pie
                                data={dataUser}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={40}
                                outerRadius={80}
                                paddingAngle={0}
                              // label={({ value }) => value}
                              >
                                {dataUser.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>

                        {/* Legend Section */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "1rem",
                          }}
                        >
                          {dataUser.map((item) => (
                            <div
                              key={item.name}
                              style={{ display: "inline-block", margin: "0 12px", fontSize: "14px" }}
                            >
                              <div style={{ color: item.color, fontWeight: "bold" }}>{item.name}</div>
                              <div className="value_Number">{item.value}</div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          height: 240,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                          color: "#888",
                          marginTop: "4.2rem"
                        }}
                      >
                        <NoResults />
                      </div>
                    )}

                  </div>
                </Card>
              </Grid>

              {/* Trending Skills */}
              <Grid className="SkillsDashboard">
                <Card>
                  {/* overflow: "scroll"  */}
                  <div style={{ padding: "1rem", height: "23.7rem", }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div className="DashPieChart">Trending Skills</div>
                      <div className="viewSkillS"
                        onClick={() => {
                          navigate(
                            `/skillsManagement`,
                            { state: { dashboardTab: "completed" } }
                          );
                        }}
                      >View All</div>
                    </div>
                    <div style={{
                      display: "flex",
                      gap: "14px",
                      marginTop: "1.5rem",
                      flexDirection: "column",
                      alignItems: "start",
                      justifyContent: "center"
                      // flexWrap: "wrap" 
                    }}>
                      {skillData && skillData.length > 0 ? (
                        skillData.map((user,) => (
                          <span className="skillsDataAll">
                            {user.skillName}
                          </span>
                        ))
                      ) : (
                        <div>No skills available</div>
                      )}
                    </div>

                  </div>
                </Card>
              </Grid>

            </Grid>


            {/* Recent Activities */}
            <Grid className="abc">
              <Grid className="Recent_Activity">
                <Card>

                  {/* <CardContent> */}
                  <div style={{ height: "29rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "1rem", alignItems: "center" }}>
                      <div className="DashPieChart">Recent Activities</div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }} >
                        <Button
                          type="button"
                          style={{
                            backgroundColor:
                              tabSwitch == "3" ? "#EEF3FF" : "#FFFFFF",
                            color: tabSwitch == "3" ? "#667085" : "#667085",
                            fontSize: "12px",
                            fontFamily: "Inter",
                            fontWeight: tabSwitch == "3" ? "500" : "500",
                            border: tabSwitch == "3" ? "1px solid #5088FB" : "1px solid #E0E2E7",
                          }}
                          onClick={() => {
                            // handleCancel();
                            setTableData([]);
                            handleServiceTypeChange("3");
                            setPage(1);
                          }}

                          disabled={tabSwitch == "3"}
                        >
                          <FaUserAlt style={{ fontSize: "1rem", marginRight: "5px", color: tabSwitch == "3" ? "#5088FB" : "#000000" }} /> New Users{" "}
                          {tabSwitch == "3"
                            ? `(${isLoading ? "" : totalDocs})`
                            : ""}
                        </Button>

                        <Button
                          type="button"
                          style={{
                            backgroundColor:
                              tabSwitch === "1" ? "#EEF3FF" : "#FFFFFF",
                            color: tabSwitch === "1" ? "#667085" : "#667085",
                            fontSize: "12px",
                            fontFamily: "Inter",
                            fontWeight: tabSwitch == "1" ? "500" : "500",
                            border: tabSwitch == "1" ? "1px solid #5088FB" : "1px solid #E0E2E7",
                          }}
                          onClick={() => {
                            // handleCancel();
                            setTableData([]);
                            handleServiceTypeChange("1");
                            setPage(1);
                          }}
                          disabled={tabSwitch == "1"}
                        >
                          <BsPinAngleFill style={{ fontSize: "1rem", marginRight: "5px", color: tabSwitch == "1" ? "#5088FB" : "#000000" }} /> New Gigs{" "}
                          {tabSwitch == "1"
                            ? `(${isLoading ? "" : totalDocs})`
                            : ""}
                        </Button>

                        <Button
                          type="button"
                          style={{
                            backgroundColor:
                              tabSwitch === "2" ? "#EEF3FF" : "#FFFFFF",
                            color: tabSwitch === "2" ? "#667085" : "#667085",
                            fontSize: "12px",
                            fontFamily: "Inter",
                            fontWeight: tabSwitch == "2" ? "500" : "500",
                            border: tabSwitch == "2" ? "1px solid #5088FB" : "1px solid #E0E2E7",

                          }}
                          onClick={() => {
                            // handleCancel();
                            setTableData([]);
                            handleServiceTypeChange("2");
                            setPage(1);
                          }}
                          disabled={tabSwitch == "2"}
                        >
                          <PiConfettiFill style={{ fontSize: "1rem", marginRight: "5px", color: tabSwitch == "2" ? "#5088FB" : "#000000" }} /> Ongoing Gigs{" "}
                          {tabSwitch == "2"
                            ? `(${isLoading ? "" : totalDocs})`
                            : ""}
                        </Button>
                      </div>
                    </div>

                    <div style={{ marginTop: "10px" }}>

                      <TableContainer className={classes.tableMainContainer}>
                        <Table className={classes.table}>
                          <TableHead>
                            <TableRow className={classes.tableHeadingRow}>
                              {tabSwitch == "3" && (
                                <>
                                  <TableCell className={classes.tableHeadingCell}>User Name</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>User Id</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Legal Name</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>
                                    <div style={{ marginLeft: "1.2rem" }}>Email</div>
                                  </TableCell>
                                </>
                              )}

                              {tabSwitch == "1" && (
                                <>
                                  <TableCell className={classes.tableHeadingCell}>Gig Details</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Job Host Name</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Host Details</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Amount ($)</TableCell>
                                </>
                              )}

                              {tabSwitch == "2" && (
                                <>
                                  <TableCell className={classes.tableHeadingCell}>Gig Details</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Gig Posted Date</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Host Name</TableCell>
                                  <TableCell className={classes.tableHeadingCell}>Job Seeker Details</TableCell>
                                </>
                              )}
                            </TableRow>
                          </TableHead>

                          {/* -------------------------------- */}
                          {/* FIXED LOADER - ALWAYS SHOW FIRST */}
                          {/* -------------------------------- */}
                          {isLoading ? (
                            <TableBody>
                              <TableRow>
                                <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                                  <Loading />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          ) : tableData && tableData.length > 0 ? (
                            <TableBody>
                              {tableData.map((user, index) => (
                                <TableRow key={user._id} className={classes.tableBodyRow}>

                                  {/* ---------------- TAB 3 USERS ---------------- */}
                                  {tabSwitch == "3" && (
                                    <>
                                      <TableCell className={classes.textMiddle}>
                                        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginLeft: "0.8rem" }}>
                                          <img
                                            src={get(user, "profileImage") || placeholder}
                                            alt="Profile"
                                            style={{ height: "40px", width: "40px", borderRadius: "8px" }}
                                          />
                                          <div>
                                            <div className="nameLeaderboardText">{get(user, "userName", "---")}</div>
                                            <div className="nameLeaderboardNumber">{get(user, "countryCode", "---")} {get(user, "phoneNumber", "---")}</div>
                                          </div>
                                        </div>
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>{get(user, "userId", "---")}</TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        {get(user, "firstName", "---")} {get(user, "lastName", "---")}
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>{get(user, "email", "---")}</TableCell>
                                    </>
                                  )}

                                  {/* ---------------- TAB 1 NEW GIGS ---------------- */}
                                  {tabSwitch == "1" && (
                                    <>
                                      <TableCell className={classes.textMiddle}>
                                        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginLeft: "0.8rem" }}>
                                          <img
                                            src={get(user, "profileImage") || placeholder}
                                            alt="Profile"
                                            style={{ height: "40px", width: "40px", borderRadius: "8px" }}
                                          />
                                          <div>
                                            <div className="nameLeaderboardText">{get(user, "gigTitle", "---")}</div>
                                            <div className="nameLeaderboardNumber">{get(user, "gigDetailId", "---")}</div>
                                          </div>
                                        </div>
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        {get(user, "firstName", "---")} {get(user, "lastName", "---")}
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        <div>{get(user, "email", "---")}</div>
                                        <div>{get(user, "countryCode", "---")} {get(user, "phoneNumber", "---")}</div>
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        {get(user, "hourlyAmount", "N/A")}
                                      </TableCell>
                                    </>
                                  )}

                                  {/* ---------------- TAB 2 ONGOING GIGS ---------------- */}
                                  {tabSwitch == "2" && (
                                    <>
                                      <TableCell className={classes.textMiddle}>
                                        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginLeft: "0.8rem" }}>
                                          <img
                                            src={
                                              get(user, "gigDetails.gigUserType") === "host"
                                                ? get(user, "hostDetails.profileImage", placeholder)
                                                : get(user, "workerDetails.profileImage", placeholder)
                                            }
                                            alt="Profile"
                                            style={{ height: "40px", width: "40px", borderRadius: "8px" }}
                                          />
                                          <div>
                                            <div className="nameLeaderboardText">{get(user, "gigDetails.gigTitle", "---")}</div>
                                            <div className="nameLeaderboardNumber">{get(user, "gigDetails.gigDetailId", "---")}</div>
                                          </div>
                                        </div>
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        {extractOnlyDate(get(user, "gigDetails.createdAt", "---"))}
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        {get(user, "hostDetails.firstName", "---")} {get(user, "hostDetails.lastName", "---")}
                                      </TableCell>

                                      <TableCell className={classes.textMiddle}>
                                        <div>{get(user, "workerDetails.firstName", "---")} {get(user, "workerDetails.lastName", "---")}</div>
                                        <div>{get(user, "workerDetails.email", "---")}</div>
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              ))}
                            </TableBody>
                          ) : (
                             <TableBody>
                              <TableRow>
                                <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                                  <Loading />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>


                      <div className="ViewTextcontent"
                        onClick={() => {
                          if (tabSwitch === "3") {
                            navigate(`/userManagement`);
                          } else if (tabSwitch === "1") {
                            navigate(`/gigsManagement`, { state: { from: "dashboard" } });
                          } else if (tabSwitch === "2") {
                            navigate(`/gigsManagement`, { state: { from: "dashboard" } });
                          }
                        }}
                      >View All</div>



                    </div>
                  </div>
                  {/* </CardContent> */}
                </Card>
              </Grid>

              {/* Leaderboard */}
              <Grid className="LeaderBoard_Data">
                <Card>

                  <div style={{ padding: "1rem", height: "29rem", }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div className="DashPieChart">Leaderboard</div>
                      <div className="DashPieChart">
                        {new Date()
                          .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                          .replace(/(\d{2}) (\w{3}) (\d{4})/, (_, d, m, y) => `${d} ${m.charAt(0).toUpperCase() + m.slice(1).toLowerCase()} ${y}`)}

                      </div>
                      <div className="viewSkillS"
                        onClick={() => {
                          navigate(
                            `/leaderboardManagement`,
                            { state: { dashboardTab: "completed" } }
                          );
                        }}
                      >View All</div>
                    </div>
                    {/* <div className="textLeadershipSkill" style={{ marginBottom: "0.4rem" }}>Top job seekers </div> */}


                    {leaderBoardData && leaderBoardData.length > 0 ? (
                      leaderBoardData.map((user, index) => (
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1.4rem", alignItems: "center", borderBottom: "1px solid #F0F1F3", }}>
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <div className="imgDashboard">

                              <img
                                src={user?.userDetails?.profileImage || placeholder}
                                style={{ height: "41px", width: "41px", borderRadius: "8px" }}
                                alt="Profile"
                              />
                            </div>
                            <div style={{
                              display: "flex", flexDirection: "column",
                              gap: "0.3rem"
                            }}>
                              <div className="nameLeaderboardText">{user.userName}</div>
                              <div className="nameLeaderboardNumber">{user.count} gigs completed</div>
                            </div>
                          </div>
                          <div className="RankDataLeaderboard">Rank {index + 1}</div>
                        </div>
                      ))
                    ) : (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "3rem"
                      }}><NoResults /></div> // Optional fallback
                    )}



                  </div>
                </Card>
              </Grid>
            </Grid>




            {/* paymentHistory */}
            <Grid className="abc">
              <Grid className="main_table_data">
                <Card>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "1rem" }}>
                    <div className="DashPieChart">Payment History</div>
                  </div>

                  <div >
                    <TableContainer className={classes.tableMainContainer}>
                      <Table className={classes.table}>
                        <TableHead>
                          <TableRow className={classes.tableHeadingRow}>
                            <TableCell className={classes.tableHeadingCell}>
                              Payment ID
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Gig Details
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell} >
                              <div style={{ marginLeft: "1rem" }}>
                                Date
                              </div>
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell} >
                              Job Host Details
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Job Seeker Details
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Total Amount
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell}>
                              Paid to Job Seeker
                            </TableCell>
                            <TableCell className={classes.tableHeadingCell} >
                              Admin Commission
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {paymentHistory && paymentHistory.length > 0 ? (
                          <>
                            <TableBody>
                              {paymentHistory.map((user, index) => (
                                <TableRow
                                  className={classes.tableBodyRow}
                                  key={user._id}
                                >
                                  <TableCell className={classes.textMiddle}>
                                    <div style={{
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#212121"

                                    }}>
                                      {get(user, "transactionId", "---")}
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", }}>
                                      <div className="imgDashboard">
                                        <img
                                          src={
                                            get(user, "gigDetails.gigUserType") === "host"
                                              ? get(user, "hostDetails.profileImage", placeholder)
                                              : get(user, "workerDetails.profileImage", placeholder)
                                          }
                                          alt="Profile"
                                          style={{ height: "40px", width: "40px", borderRadius: "8px" }}
                                        />
                                      </div>
                                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                                        <div className="nameLeaderboardText">{get(user, "gigDetails.gigTitle", "---")}</div>
                                        <div className="nameLeaderboardNumber">{get(user, "gigDetails.gigDetailId", "---")}</div>
                                      </div>
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div className="recentTabledata">
                                      {extractOnlyDate(get(user, "createdAt", "---"))}
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                                      <div className="nameLeaderboardText">{get(user, "hostDetails.userName", "---")}</div>
                                      <div className="nameLeaderboardNumber">{get(user, "hostDetails.email", "---")}</div>
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                                      <div className="nameLeaderboardText">{get(user, "workerDetails.userName", "---")}</div>
                                      <div className="nameLeaderboardNumber">{get(user, "workerDetails.email", "---")}</div>
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>

                                    <div className="recentTabledata" style={{ marginLeft: "1rem" }}>
                                      ${get(user, "totalAmountForGig", "---") !== "---"
                                        ? Number(get(user, "totalAmountForGig", 0)).toFixed(2)
                                        : "---"}
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div className="recentTabledata" style={{ marginLeft: "2.5rem" }}>
                                      ${get(user, "amount", "---") !== "---"
                                        ? Number(get(user, "amount", 0)).toFixed(2)
                                        : "---"}
                                    </div>
                                  </TableCell>
                                  <TableCell className={classes.textMiddle}>
                                    <div className="recentTabledata" style={{ marginLeft: "3rem" }}>

                                      ${get(user, "totalPlatformCommissionFee", "---") !== "---"
                                        ? Number(get(user, "totalPlatformCommissionFee", 0)).toFixed(2)
                                        : "---"}
                                    </div>
                                  </TableCell>


                                </TableRow>
                              ))}
                            </TableBody>
                          </>
                        ) : (
                          <>
                            <TableBody>
                              <TableRow>
                                <TableCell
                                  colSpan={13}
                                  align="center"
                                  style={{ padding: "2rem" }}
                                >
                                  <DashHeading
                                    style={{ textAlign: "center", padding: "2rem" }}
                                  >
                                    No Data Found !!
                                  </DashHeading>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </>
                        )}
                      </Table>
                    </TableContainer>

                    <div className="ViewTextcontent"
                      onClick={() => {
                        navigate(
                          `/paymentManagement`
                        );
                      }}
                    >View All</div>
                  </div>
                </Card>
              </Grid>
            </Grid>

          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
